const SideNum = ({titulo, num}) => {
    return(
        <div className="text-center bg-gradient-to-b from-emerald-800 to-emerald-600 shadow-md shadow-emerald-500 w-full py-7 px-1 rounded-lg">
            <p className="text-xl">{titulo}</p>
            <span className="text-2xl">{num}</span>
        </div>
    )
}

export default SideNum